module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "content"
  }, [_c('section', {
    staticClass: "content-header"
  }, [_c('div', {
    staticClass: "container-fluid"
  }, [_c('div', {
    staticClass: "page-header"
  }, [_c('h1', [_vm._v(_vm._s(_vm.$t(_vm.$route.name)))])])])]), _vm._v(" "), (_vm.dataReady) ? _c('div', {
    staticClass: "container-fluid"
  }, [_c('div', {
    staticClass: "card"
  }, [_c('div', {
    staticClass: "card-block row"
  }, [_c('table', {
    staticClass: "table table-striped table-no-bordered table-hover table-responsive",
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "id": "datatables",
      "cellspacing": "0",
      "width": "100%"
    }
  }, [_vm._m(0), _vm._v(" "), _c('tbody', _vm._l((_vm.records.items), function(registration) {
    return _c('tr', {
      attrs: {
        "role": "row"
      }
    }, [_c('td', [_c('router-link', {
      attrs: {
        "to": '/moderate/registration/' + registration.id
      }
    }, [_vm._v(_vm._s(registration.name))])], 1), _vm._v(" "), _c('td', [_c('span', {
      class: 'badge badge-' + {
        new: 'info',
        edited: 'success',
        rejected: 'danger'
      }[registration.status]
    }, [_vm._v(_vm._s(_vm.$t('status.family_' + registration.status)))])]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.$config.lists.countries[registration.country].text) + " / " + _vm._s(_vm.$config.lists.states[registration.state].text))]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_c('router-link', {
      staticClass: "btn btn-small btn-primary btn-icon edit",
      attrs: {
        "to": '/moderate/registration/' + registration.id
      }
    }, [_c('i', {
      staticClass: "fa fa-eye"
    })])], 1)])
  }))])])])]) : _vm._e(), _vm._v(" "), _c('f-pager', {
    attrs: {
      "total": _vm.records.total,
      "clickhandler": _vm.pageClick
    }
  })], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('tr', [_c('th', {
    staticClass: "sorting_asc",
    staticStyle: {
      "width": "143px"
    },
    attrs: {
      "tabindex": "0"
    }
  }, [_vm._v("Име")]), _vm._v(" "), _c('th', {
    staticClass: "sorting",
    staticStyle: {
      "width": "215px"
    },
    attrs: {
      "tabindex": "0"
    }
  }, [_vm._v("Статус")]), _vm._v(" "), _c('th', {
    staticClass: "sorting",
    staticStyle: {
      "width": "107px"
    },
    attrs: {
      "tabindex": "0"
    }
  }, [_vm._v("Град")]), _vm._v(" "), _c('th', {
    staticClass: "sorting",
    staticStyle: {
      "width": "10px"
    },
    attrs: {
      "tabindex": "0"
    }
  }, [_vm._v("Действия")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-20ee61c6!./~/vue-loader/lib/selector.js?type=template&index=0!./~/htmlhint-loader?{"configFile":".htmlhintrc.json","failOnError":true}!./src/components/admin/RegistrationList.vue
// module id = 642
// module chunks = 1